<div class="modal-header">
  <h5 class="modal-title">{{ title() }}</h5>
</div>

<div class="modal-body p-3">
  <div class="d-flex gap-3 mb-3">
    <span class="badge bg-success" i18n>New: {{ newCount() }}</span>
    <span class="badge bg-primary" i18n>Update: {{ updateCount() }}</span>
    <span class="badge bg-danger" i18n>Errors: {{ invalidCount() }}</span>
    <span class="badge bg-warning text-dark" i18n>Warnings: {{ warningCount() }}</span>
    <span class="badge bg-secondary" i18n>Total: {{ rowData().length }}</span>
  </div>

  @if (hasErrors()) {
    <div class="alert alert-danger mb-3" i18n>
      Import cannot proceed while there are rows with errors. Please correct the data and try again.
    </div>
  }

  <!--
    No stateKey, deliberately: this modal previews EVERY import, so its columns are whatever
    the entity being imported has. One shared key would apply one import's saved layout to
    another's columns - the same hazard as the warp/weft plan grid. It would need a key per
    import type, which is worth doing only if someone asks for it.
  -->
  <app-grid
    gridCssClass="import-preview-modal-grid"
    [columnDefs]="columnDefs()"
    [rowData]="rowData()"
    [filter]="true"
    [resizable]="true"
    [sortable]="true"
    [showDelete]="false"
  ></app-grid>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="modalService.dismiss()" i18n>Cancel</button>
  <button class="btn btn-success" [disabled]="hasErrors()" (click)="confirmImport()">
    <i class="fas fa-check me-1"></i><span i18n>Confirm Import</span> ({{ validCount() }} rows)
  </button>
</div>
